//OFFLINESTORE
export const ALL_OFFLINESTORE_REQUEST = "ALL_OFFLINESTORE_REQUEST";
export const ALL_OFFLINESTORE_SUCCESS = "ALL_OFFLINESTORE_SUCCESS";
export const ALL_OFFLINESTORE_FAIL = "ALL_OFFLINESTORE_FAIL";

export const ALL_OFFLINESTORE_COMPANY_REQUEST = "ALL_OFFLINESTORE_COMPANY_REQUEST";
export const ALL_OFFLINESTORE_COMPANY_SUCCESS = "ALL_OFFLINESTORE_COMPANY_SUCCESS";
export const ALL_OFFLINESTORE_COMPANY_FAIL = "ALL_OFFLINESTORE_COMPANY_FAIL";